import React, { FC, ReactNode } from 'react';

import styles from './researchFormWizardStyles.scss';

const ResearchFormWizardSection: FC<{
  title: string;
  children: ReactNode;
}> = ({ title, children }) => {
  return (
    <div className={styles.researchFormWizardSection}>
      <div className={styles.researchFormWizardSectionHeader}>
        <h4>{title}</h4>
      </div>
      {children}
    </div>
  );
};

export default ResearchFormWizardSection;
